import * as allIcons from '@fortawesome/free-solid-svg-icons'
const getIconsArr = () => {
  const { fas, prefix, ...rest } = allIcons
  return Object.values(rest)
}

const icons = [...getIconsArr()]
export default icons
